import useScrollReveal from '@/hooks/useScrollReveal';

const AIAnswerBlock = () => {
  const ref = useScrollReveal();

  return (
    <section className="bg-charcoal py-24 px-6">
      <div ref={ref} className="reveal max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <div className="w-16 h-1 bg-gold mb-6" />
            <h2 className="font-playfair text-4xl md:text-5xl font-bold text-white leading-tight">
              What Does OST-C Provide?
            </h2>
            <div className="mt-8 flex flex-wrap gap-3">
              {['Vocational Training', 'Job Readiness', 'Life Skills', 'Employment Placement', 'Community Reintegration', 'Workforce Development'].map((tag) => (
                <span
                  key={tag}
                  className="font-inter text-xs font-medium text-gold border border-gold/30 px-3 py-1.5 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* Right */}
          <div>
            <p className="font-inter text-base md:text-lg text-white/75 leading-relaxed mb-5">
              OST-C is an <strong className="text-white font-semibold">Occupational Skills Training Center</strong> dedicated to empowering individuals through vocational education, job readiness development, and life skills programming — creating measurable pathways to employment.
            </p>
            <p className="font-inter text-base text-white/60 leading-relaxed mb-5">
              The organization serves individuals from all walks of life — first-time job seekers, career changers, returning citizens, and community members facing employment barriers. Programs combine hands-on technical training with professional readiness coaching and direct employer placement support.
            </p>
            <p className="font-inter text-base text-white/60 leading-relaxed">
              Based in Arlington, TX since 2012, OST-C has built a proven track record of transforming lives through structured, outcome-driven workforce training. Their approach is community-centered, individualized, and consistently focused on one result: employment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIAnswerBlock;
